'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var utils$1 = require('@chakra-ui/utils');
var React = require('react');
var utils = require('./utils.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var _excluded = ["size"],
  _excluded2 = ["size", "max", "min", "valueText", "getValueText", "value", "children"];

/**
 * This calculates the circumference and right starting point (stroke-dashoffset) of the process indicator according to it's radius.
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-dashoffset
 */
var RADIUS = 46;
var CIRCUMFERENCE = 46 * 2 * Math.PI;
var CIRCUMFERENCE_PERCENTAGE = CIRCUMFERENCE / 100;
var STROKE_DASHOFFSET = CIRCUMFERENCE / 4;
/**
 * The indicator circle - defines the track itself and also the colored indicator stroke
 */
var Circle = function Circle(props) {
  return /*#__PURE__*/React__namespace.createElement(react.chakra.circle, _extends__default["default"]({
    cx: 50,
    cy: 50,
    r: RADIUS,
    fill: "transparent"
  }, props));
};
/**
 * The outer svg shape that sets the viewBox and given size of the circular progress
 */
var Shape = function Shape(props) {
  var size = props.size,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  return /*#__PURE__*/React__namespace.createElement(react.chakra.svg, _extends__default["default"]({
    viewBox: "0 0 100 100",
    __css: {
      width: size,
      height: size
    }
  }, rest));
};
/**
 * CircularProgress is used to indicate the progress of an activity.
 * It is built using `svg` and `circle` components with support for
 * theming
 *
 * @see Docs https://chakra-ui.com/circularprogress
 */
var CircularProgress = react.forwardRef(function (props, ref) {
  var _progress$percent;
  var size = props.size,
    _props$max = props.max,
    max = _props$max === void 0 ? 100 : _props$max,
    _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    valueText = props.valueText,
    getValueText = props.getValueText,
    value = props.value,
    children = props.children,
    rest = _objectWithoutProperties__default["default"](props, _excluded2);
  var progress = utils.getProgressProps({
    min: min,
    max: max,
    value: value,
    valueText: valueText,
    getValueText: getValueText
  });

  /**
   * "Length" of the colored indicator on the track calculated with the given value and the circumference
   */
  var determinant = ((_progress$percent = progress.percent) !== null && _progress$percent !== void 0 ? _progress$percent : 0) * CIRCUMFERENCE_PERCENTAGE;

  /**
   * Indicator start and end [strokeLength, gapLength]
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-dasharray
   */
  var strokeDasharray = utils$1.isUndefined(determinant) ? undefined : "".concat(determinant, " ").concat(CIRCUMFERENCE - determinant);

  /**
   * all props needed for generating the colored progress indicator
   */
  var indicatorProps = {
    strokeDashoffset: STROKE_DASHOFFSET,
    strokeDasharray: strokeDasharray,
    transitionProperty: 'stroke-dasharray, stroke',
    transitionDuration: '0.6s',
    transitionTimingFunction: 'ease'
  };

  /**
   * Styles of the theme file to pass on with the StylesProvider
   */
  var styles = react.useMultiStyleConfig('CircularProgress', props);

  /**
   * rootStyles of the container needed here due to css hierachy reasons
   */
  var rootStyles = {
    display: 'inline-block',
    position: 'relative',
    verticalAlign: 'middle',
    fontSize: size
  };
  return /*#__PURE__*/React__namespace.createElement(react.StylesProvider, {
    value: styles
  }, /*#__PURE__*/React__namespace.createElement(react.chakra.div, _extends__default["default"]({
    className: "chakra-progress"
  }, progress.bind, rest, {
    ref: ref,
    __css: rootStyles
  }), /*#__PURE__*/React__namespace.createElement(Shape, {
    size: size
  }, /*#__PURE__*/React__namespace.createElement(Circle, {
    __css: styles.track,
    className: "chakra-progress__track"
  }), /*#__PURE__*/React__namespace.createElement(Circle, _extends__default["default"]({
    __css: styles.indicator,
    className: "chakra-progress__indicator"
    /**
     * fix issue in Safari and chrome where indicator still shows when value is 0
     * @see Issue https://github.com/chakra-ui/chakra-ui/issues/3754
     */,
    opacity: progress.value === min ? 0 : undefined
  }, indicatorProps))), children));
});
CircularProgress.displayName = 'CircularProgress';
exports.CircularProgress = CircularProgress;